import { AllegatoBase64Model, fnBase64Ext } from '@app-lib/export/web';

export function fnGetMimeType_Base64Model(data: AllegatoBase64Model): AllegatoBase64Model {
  if (data.Base64 == null) {
    return data;
  }
  try {
    // sanitizza le stringhe e tronca a 50 caratteri
    const maxchar: number = 50;
    if (data.FileName != null) {
      const x = data.FileName.replace('</?([Ws_]+)/?>', '_');

      if (x.length > maxchar) {
        const index = x.length - maxchar;
        data.FileName = data.FileName.slice(index);
      }
      let ex = data.FileName;
      let dot = ex.lastIndexOf('.');
      // non trova l'indice
      if (dot != -1) {
        data.Extension = ex.slice(((dot - 1) >>> 0) + 2);
      }
      // elimina l'estensione dal filename
      data.FileName = data.FileName.substring(0, data.FileName.lastIndexOf('.'));
      // toglie i punti residui
      data.FileName = data.FileName.replace(/\./g, ' ');
    } else {
      // mette un timestamp per nome
      data.FileName = Date.now().toString();
    }
    data.MimeType = data.Base64.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0];
    data.MediaType = data.Base64.match(/[^:/]\w+(?=\/|,)/)[0];
    // rimuove l'header per il server asp
    data.Base64 = data.Base64.substring(data.Base64.lastIndexOf(',') + 1);
    // se proprio non ha l'estensione prova a ricavare da base64 soprattutto se è un'immagine
    if (data.Extension == null || data.Extension.length == 0) {
      data.Extension = fnBase64Ext(data.Base64);
    }
    // sanitizza il nome del folder
    if (data.Folder != null) {
      const fold = data.Folder.replace('</?([Ws_]+)/?>', '_');
      if (fold.length > maxchar) {
        const index = fold.length - maxchar;
        data.FileName = data.FileName.slice(index);
      }
    }
    return data;
  } catch (e) {
    console.error('NF.FN.B64.EX.00' + e);
  }
}
